var siteIdentifier = "";
function extractSubdomain(url) {
  var parts = url.split("/");
  if (parts.length >= 3) {
    var subdomainPart = parts[4]; // Index 2 contains the subdomain part
    var subdomainParts = subdomainPart.split(".");
    return subdomainParts.join(".");
  } else {
    return null;
  }
}
export function getSiteIdentifier(url = " ") {
  if (siteIdentifier?.length > 0) return siteIdentifier;
  else {
    siteIdentifier = extractSubdomain(url);
    return siteIdentifier;
  }
}

export function getSiteUrl(url = "") {
  var feUrl = "";
  switch (getSiteIdentifier(url)) {
    case "GTLaw.dexterity.legal":
      feUrl = "https://gtlaw.dexterity.legal/home";
      break;
    case "dexterity-9l-dev":
      feUrl = "https://dev.dexterity.legal/home";
      break;
    case "dexterity-prod3":
      feUrl = "https://preprod.dexterity.legal/home";
      break;
    case "mac":
      feUrl = "https://mac.dexterity.legal/home";
      break;
    case "GTlaw1.dexterity.legal":
      feUrl = "https://gtlaw1.dexterity.legal/home";
      break;
    case "production":
      feUrl = "https://app.dexterity.legal/home";
      break;
    case "gtlaw2":
      feUrl = "https://gtlaw2.dexterity.legal/home";
      break;
    case "pentest":
      feUrl = "https://pentest.dexterity.legal/home";
      break;
    default:
      feUrl = "https://dev.dexterity.legal/home";
  }
  return feUrl;
}
